<template>
   <router-view></router-view>
</template>
<script>
export default {
  name: "adware-vue"
};
</script>
<style scoped>
#login {
  background-image: url(https://picsum.photos/1200/?random&blur);
  background-size: cover;
}
</style>
